<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《黑石启示》是根据鬼灭题材改编的策略卡牌手游，游戏内高度还原所有动漫角色及剧情玩法，并根据题材的内容衍生不同玩法及养成线。沿着故事篇章探索，多元化互动玩法，以及独特的收集模式，让玩家可以快速收集到喜爱的动漫人物，达成最理想的阵容及培养人物。高自由度的刺激战斗、炫酷技能的表现、开启了险象环生复仇之路。</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【十二之柱，任你差遣】</h4>
        富冈义勇、宇髓天元、炼狱杏寿郎等等顶级之柱，皆在你的掌控中！
        <img src="/2.png" alt="" />
      </div>
      <div class="content-item">
        <h4>【策略布阵，解放双手】</h4>
        肉盾、攻杀、术师、控魂；不同定位，巧妙布阵，克制强敌。
        <img src="/3.png" alt="" />
      </div>
      <div class="content-item">
        <h4>【符文技能，多种搭配】</h4>
        每位英雄除了自有的技能，还能搭配不同符文、技能练就属于你自己的强大英雄。
        <img src="/4.png" alt="" />
      </div>
      <div class="content-item">
        <h4>【多种玩法，与众不同】</h4>
        摆脱传统类游戏玩法单调的问题，加入多种不同副本玩法，打造独一无二的游戏方式。
        <img src="/5.png" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
